export interface LearnPost {
  id?: string
  imgUrl: string
  imgAlt: string
  section: string
  header: string
  content: string
  disclaimer?: string
  path: string
  metaTitle?: string
  metaDescription?: string
  ogTitle?: string
  ogDescription?: string
  ogImg?: string
}

export interface LearnPostIndex {
  post: { [key: string]: LearnPost }
  count: number
}

export interface LearnPosts {
  post: LearnPost[]
  count: {
    post: number
  }
}

export interface ImageProps {
  src: string
  aspect?: ImageAspect
  alt?: string
}

export enum ImageAspect {
  Square = "square",
  Landscape = "landscape"
}

export enum LearnSections {
  "what-is-a-migraine" = "Migraine Questions",
  "migraine-treatment" = "Migraine Treatments",
  "living-with-migraines" = "Living With Migraines"
}
